import classNames from 'classnames'
import React, { useEffect, useState } from 'react'

import styles from './styles/anchor_button.module.scss'

const AnchorButton = ({ isFooterVisible }) => {
  const [windowIsUp, setWindowIsUp] = useState(false);


  const anchorClasses = classNames({
    [styles["anchor_button--hide"]]: isFooterVisible || !windowIsUp,
    [styles.anchor_button]: true
  })

  useEffect(() => {
    const headerHeight = document.getElementById("header").offsetHeight;

    window.addEventListener("scroll", () => {
      if (window.scrollY > headerHeight) {
        setWindowIsUp(true);
      } else {
        setWindowIsUp(false);
      }
    })

    return () => window.removeEventListener("scroll", () => { });
  }, []);


  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className={anchorClasses}>
      <button onClick={scrollToTop}>
        <svg className={styles.anchor_button__icon} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="24" fill="currentColor" />
          <g clipPath="url(#clip0_8191_32159)">
            <path d="M19.41 27.41L24 22.83L28.59 27.41L30 26L24 20L18 26L19.41 27.41Z" fill="#222222" />
          </g>
          <defs>
            <clipPath id="clip0_8191_32159">
              <rect width="24" height="24" fill="white" transform="translate(12 12)" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>
  )
}

export default AnchorButton